// apps/client/src/hooks/useDeleteClientSet.ts
import { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

interface UseDeleteClientSetReturn {
  deleteClientSet: (clientSetId: string) => Promise<boolean>;
  loading: boolean;
  error: string | null;
}

/**
 * Hook to delete a client set
 */
export function useDeleteClientSet(): UseDeleteClientSetReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteClientSet = async (clientSetId: string): Promise<boolean> => {
    if (!clientSetId) {
      setError('Client set ID is required');
      return false;
    }

    setLoading(true);
    setError(null);

    try {
      console.log(`[useDeleteClientSet] Deleting client set ${clientSetId}`);

      const deleteClientSetFunc = httpsCallable<
        { clientSetId: string },
        { success: boolean }
      >(functions, 'deleteClientSet');

      const result = await deleteClientSetFunc({ clientSetId });

      console.log(`[useDeleteClientSet] Delete successful:`, result.data.success);

      return result.data.success;
    } catch (err) {
      console.error('[useDeleteClientSet] Error deleting client set:', err);
      setError(err instanceof Error ? err.message : 'Failed to delete client set');
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    deleteClientSet,
    loading,
    error,
  };
}
